/**
 * The following code is copied and modified versions from
 * https://www.npmjs.com/package/uuid
 * Licensed under MIT license
 */
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
const rnds8 = new Uint8Array(16);
function rng() {
    return crypto.getRandomValues(rnds8);
}
// Regex used to validate that the final stringified regex conforms to the standard.
const validate_regex = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(uuid) {
    return validate_regex.test(uuid);
}
// LUT for converting byte to hex string
const byte_to_hex = [];
for (let i = 0; i < 256; ++i) {
    byte_to_hex.push((i + 0x100).toString(16).substring(1));
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
function stringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    const uuid = (byte_to_hex[arr[offset + 0]] + byte_to_hex[arr[offset + 1]] + byte_to_hex[arr[offset + 2]] + byte_to_hex[arr[offset + 3]] + '-' + byte_to_hex[arr[offset + 4]] + byte_to_hex[arr[offset + 5]] + '-' + byte_to_hex[arr[offset + 6]] + byte_to_hex[arr[offset + 7]] + '-' + byte_to_hex[arr[offset + 8]] + byte_to_hex[arr[offset + 9]] + '-' + byte_to_hex[arr[offset + 10]] + byte_to_hex[arr[offset + 11]] + byte_to_hex[arr[offset + 12]] + byte_to_hex[arr[offset + 13]] + byte_to_hex[arr[offset + 14]] + byte_to_hex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
export function uuidv4() {
    const rnds = rng();
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    return stringify(rnds);
}
//# sourceMappingURL=uuidv4.js.map